import { Name } from 'src/app/shared/models/general.models'
import { serviceDetails } from 'src/app/modules/services/models/service-template.model'

export interface packageFilter {
	SearchText: string
	paging: {
		pageNumber: number
		pageSize: number
	}
}
export interface Package {
	id?: number
	name: Name
	description: Name
	image: string
	startDate: string
	endDate: string
	isActive: boolean
	canBook: boolean
	price: number
	instructions: Name
	packageServices: serviceDetails[]
	branchId: number
	hasBooking?: boolean
}
export class createPackage {
	isActive: boolean = false
	name: Name = {
		en: '',
		ar: '',
	}
	description: Name = {
		en: '',
		ar: '',
	}
	image: string = ''
	startDate: string = ''
	endDate: string = ''
	packageServices: serviceDetails[] = []
	canBook: boolean = false
	price: number = 0
	instructions: Name = {
		en: '',
		ar: '',
	}
	branchId: number = 0
}

export interface PackageFilter {
	paging: {
		pageNumber: number
		pageSize: number
	}
	searchText: string
	branchId: number
}
export interface PackageData {
	id: number
	name: {
		en: string
		ar: string
	}
	description: {
		en: string
		ar: string
	}
	image: string
	startDate: string
	endDate: string
	isActive: boolean
	canBook: boolean
	price: number
	instructions: {
		en: string
		ar: string
	}
	hasBooking: boolean
	duration?: string
	packageServices: [
		{
			id: number
			duration: string
			name: {
				en: string
				ar: string
			}
		}
	],
	currency: {
		name: {
			en: string,
			ar: string
		},
		id: number
	}
}

export interface PackageFilter {
	paging: {
		pageNumber: number
		pageSize: number
	}
	searchText: string
	branchId: number
}
